import React from "react";
import SbEditable from "storyblok-react";
import RichText from "src/utils/RichText";
import Label from "src/components/Label";
import Heading from "src/components/Heading";
import Wave from "src/utils/Wave";
import { Link } from "gatsby";
import resolveLink from "src/utils/resolveLink";
import ArrowButton from "src/components/ArrowButton";
import TBBLink from "utils/TBBLink";

const WithFeatureGridLisItem = (props) => {
  const children = (
    <>
      <div>
        <div
          className={`prose reduce-top-space font-display  tracking-[-0.5px] !leading-5mt-6 max-w-2xl  duration-300 `}
        >
          <RichText>{props.title}</RichText>
        </div>
        <p className={`prose text-darkblue-700 mt-4 text-sm lg:mt-6`}>
          <RichText>{props.description}</RichText>
        </p>
      </div>
      {props.target?.cached_url && (
        <ArrowButton className="mt-6 lg:mt-10">{props.button_text}</ArrowButton>
      )}
    </>
  );
  return props.target?.cached_url ? (
    <TBBLink
      to={props.target?.cached_url}
      className="group flex flex-col justify-between"
      target={props.target?.linktype === "url" ? "_blank" : ""}
    >
      {children}
    </TBBLink>
  ) : (
    <div className="group flex flex-col justify-between">{children}</div>
  );
};

const WithFeatureGridList = ({ blok }) => {
  return (
    <SbEditable content={blok} key={blok._uid}>
      <div>
        {blok.lightblue_background && (
          <Wave className="fill-lightblue" flip scale />
        )}
        <div
          className={`relative ${
            blok.lightblue_background ? "bg-lightblue" : "bg-white"
          }`}
        >
          <div
            className={`relative mx-auto max-w-6xl px-6 ${
              blok.lightblue_background ?
               "py-20 lg:py-24" 
               :
              ` ${blok.marginBottom?`mb-${blok.marginBottom}`:'mb-28'}
               ${blok.marginTop?`mt-${blok.marginTop}`:'mt-28'}
              lg: ${blok.marginBottom?`mb-${parseInt(blok.marginBottom,10)+12}`:'mb-40'}
              lg: ${blok.marginTop?`mt-${parseInt(blok.marginTop,10)+12}`:'mt-40'}`
            }`}
          >
            <div>
              <Label
                className={`${
                  blok.lightblue_background
                    ? "text-darkblue-400"
                    : "text-lightblue-300"
                }`}
                p={true}
              >
                {blok.label}
              </Label>
              <Heading
                size="h2"
                className="prose text-darkblue brightgreenBold mt-6 max-w-2xl not-prose"
              >
                <RichText>{blok.title}</RichText>
              </Heading>
              <p className="prose text-darkblue-700 mt-6 max-w-2xl">
                <RichText>{blok.description}</RichText>
              </p>
              <img
                src={blok.image?.filename}
                alt={blok.image?.filename}
                className="absolute -top-40 right-0 hidden max-w-[400px] lg:block"
              />
            </div>
            <div className="mt-16 grid gap-10 md:grid-cols-2 md:gap-16 lg:mt-24 lg:grid-cols-4">
              {blok.items.map((item) => (
                <WithFeatureGridLisItem {...item} key={item._uid} />
              ))}
            </div>
          </div>
        </div>
        {blok.lightblue_background && <Wave className="fill-lightblue" />}
      </div>
    </SbEditable>
  );
};

export default WithFeatureGridList;
